import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import MDBox from "../components/MDBox";
import CircularProgress from "@mui/material/CircularProgress";

const GuestGuard = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <MDBox display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress color="info" />
            </MDBox>
        );
    }

    if (isAuthenticated) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default GuestGuard;
